import PropTypes from 'prop-types';
import SpinnerIcon from '@activebrands/core-web/components/icons/SpinnerIcon';
import AdyenDropInContainer from '@activebrands/core-web/containers/AdyenPaymentContainer';
import { styled } from '@activebrands/core-web/libs/styletron';

const Div = styled('div', {
    minHeight: '35vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
});

const AdyenDropIn = ({ loading = false, setLoading = () => null }) => (
    <>
        <AdyenDropInContainer
            render={({ isLoaded }) => {
                setLoading(!isLoaded);
                return loading ? (
                    <Div>
                        <SpinnerIcon />
                    </Div>
                ) : null;
            }}
        />
        <div id="adyen-checkout-container" />
    </>
);

AdyenDropIn.propTypes = {
    loading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
};

export default AdyenDropIn;
